import ScenariosPage from "@Quest/CorporateScenarios/Pages/ScenariosPage.vue";
import SettingsPage from "@Quest/CorporateScenarios/Pages/SettingsPage.vue";
import ProjectsPage from "@Quest/CorporateScenarios/Pages/ProjectsPage.vue";
import SchedulingPage from "@Quest/CorporateScenarios/Pages/SchedulingPage.vue";
import PortfoliosPage from "@Quest/CorporateScenarios/Pages/PortfoliosPage.vue";
import PnlPage from "@Quest/CorporateScenarios/Pages/PnlPage.vue";



export const routes = [
    {
        path: "/enterprise/planning/:workspaceId/:strategyId",
        component: ScenariosPage
    },
    {
        path: "/enterprise-plan/settings/:workspaceId/:strategyId/:scenarioId?",
        component: SettingsPage
    },

    {
        path: "/enterprise-plan/projects/:workspaceId/:strategyId/:scenarioId",
        component: ProjectsPage
    },
    {
        path: "/enterprise-plan/schedule/:workspaceId/:strategyId/:scenarioId",
        component: SchedulingPage
    },
    {
        path: "/enterprise-plan/portfolios/:workspaceId/:strategyId/:scenarioId",
        component: PortfoliosPage
    },

    {
        path: "/enterprise-plan/pnl/:workspaceId/:strategyId/:scenarioId",
        component: PnlPage
    },
]
